import { padNumber } from "@/src/helpers/padNumber";
import { CountdownTimeMapType } from "./types";

export const formatCountdownTimeMap = (
  countdownTimeMap: CountdownTimeMapType,
) => {
  return [
    countdownTimeMap.get("days"),
    countdownTimeMap.get("hours"),
    countdownTimeMap.get("minutes"),
    countdownTimeMap.get("seconds"),
  ].join(":");
};

export const ONE_SECOND_MS = 1000;
export const SECONDS_IN_A_MIN = 60;
export const MINUTES_IN_AN_HOUR = 60;
export const HOURS_IN_A_DAY = 24;

export const TIME_IN_DAY =
  SECONDS_IN_A_MIN * MINUTES_IN_AN_HOUR * HOURS_IN_A_DAY;
export const TIME_IN_HOURS = SECONDS_IN_A_MIN * MINUTES_IN_AN_HOUR;
export const TIME_IN_MINUTES = MINUTES_IN_AN_HOUR;
export const TIME_IN_SECONDS = SECONDS_IN_A_MIN;

export const getTimeUntilDateTime = (dateTime: string | Date) => {
  if (!dateTime) return null;

  const givenDateTimeMs = new Date(dateTime).getTime();
  const nowDateTimeMs = new Date().getTime();

  const distance = givenDateTimeMs - nowDateTimeMs;

  if (distance < 0) return null;

  const days = Math.floor(distance / (ONE_SECOND_MS * TIME_IN_DAY));
  const hours = Math.floor(
    (distance % (ONE_SECOND_MS * TIME_IN_DAY)) /
      (ONE_SECOND_MS * TIME_IN_HOURS),
  );
  const minutes = Math.floor(
    (distance % (ONE_SECOND_MS * TIME_IN_HOURS)) /
      (ONE_SECOND_MS * TIME_IN_MINUTES),
  );
  const seconds = Math.floor(
    (distance % (ONE_SECOND_MS * TIME_IN_SECONDS)) / ONE_SECOND_MS,
  );

  return {
    days: padNumber(days, 2),
    hours: padNumber(hours, 2),
    minutes: padNumber(minutes, 2),
    seconds: padNumber(seconds, 2),
  };
};
